import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const UserAccountsTab = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const userAccounts = [
  {
    id: 1,
    name: 'Priya Sharma',
    email: 'priya.sharma@gmail.com',
    phone: '+91 9876543210',
    userType: 'Customer',
    submissionDate: '2024-10-26',
    status: 'pending',
    location: 'Mumbai, Maharashtra',
    profileImage: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=300',
    documents: ['Aadhaar Card', 'PAN Card'],
    verificationScore: 85,
    flaggedIssues: ['Phone number verification pending'],
    joinDate: '2024-10-20',
    accountActivity: 'Active',
    kycStatus: 'In Progress'
  },
  {
    id: 2,
    name: 'Rajesh Kumar',
    email: 'rajesh.k@business.com',
    phone: '+91 9123456789',
    userType: 'Service Provider',
    submissionDate: '2024-10-25',
    status: 'under_review',
    location: 'Delhi NCR',
    profileImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300',
    documents: ['Aadhaar Card', 'Business License', 'Bank Details'],
    verificationScore: 92,
    flaggedIssues: [],
    joinDate: '2024-10-18',
    accountActivity: 'Active',
    kycStatus: 'Under Review'
  },
  {
    id: 3,
    name: 'Anita Patel',
    email: 'anita.patel@restaurant.com',
    phone: '+91 9987654321',
    userType: 'Restaurant Owner',
    submissionDate: '2024-10-24',
    status: 'approved',
    location: 'Ahmedabad, Gujarat',
    profileImage: "https://images.unsplash.com/photo-1555634599-459fed78173a",
    documents: ['Aadhaar Card', 'FSSAI License', 'GST Registration'],
    verificationScore: 98,
    flaggedIssues: [],
    joinDate: '2024-10-15',
    accountActivity: 'Active',
    kycStatus: 'Verified'
  },
  {
    id: 4,
    name: 'Mohammed Ali',
    email: 'mohammed.ali@delivery.com',
    phone: '+91 9654321098',
    userType: 'Delivery Partner',
    submissionDate: '2024-10-23',
    status: 'rejected',
    location: 'Hyderabad, Telangana',
    profileImage: "https://images.unsplash.com/photo-1695654394614-576ba40957f3",
    documents: ['Aadhaar Card', 'Driving License'],
    verificationScore: 65,
    flaggedIssues: ['Invalid driving license', 'Address mismatch'],
    joinDate: '2024-10-20',
    accountActivity: 'Suspended',
    kycStatus: 'Rejected'
  }];


  const statusColumns = [
  { id: 'pending', label: 'Pending Review', color: 'yellow' },
  { id: 'under_review', label: 'Under Verification', color: 'blue' },
  { id: 'approved', label: 'Approved', color: 'green' },
  { id: 'rejected', label: 'Rejected', color: 'red' }];


  const filteredUsers = userAccounts?.filter((user) => {
    if (filter !== 'all' && user?.status !== filter) return false;
    if (searchQuery && !user?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) &&
    !user?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase())) return false;
    return true;
  });

  const getUsersByStatus = (status) => {
    return filteredUsers?.filter((user) => user?.status === status);
  };

  const handleApprove = (user) => {
    console.log('Approving user:', user?.id);
  };

  const handleReject = (user) => {
    console.log('Rejecting user:', user?.id);
  };

  const getUserTypeIcon = (userType) => {
    switch (userType) {
      case 'Customer':return 'User';
      case 'Service Provider':return 'Tool';
      case 'Restaurant Owner':return 'UtensilsCrossed';
      case 'Delivery Partner':return 'Truck';
      default:return 'User';
    }
  };

  const getUserTypeColor = (userType) => {
    switch (userType) {
      case 'Customer':return 'bg-blue-100 text-blue-800';
      case 'Service Provider':return 'bg-green-100 text-green-800';
      case 'Restaurant Owner':return 'bg-purple-100 text-purple-800';
      case 'Delivery Partner':return 'bg-orange-100 text-orange-800';
      default:return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="flex h-full">
      {/* Main Content */}
      <div className={`transition-all duration-300 ${selectedUser ? 'flex-1' : 'w-full'}`}>
        {/* Filters */}
        <div className="p-6 border-b border-border bg-card">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <Input
                placeholder="Search users by name or email..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
                className="w-full" />

            </div>
            <Select
              value={filter}
              onValueChange={setFilter}
              className="w-full sm:w-48">

              <option value="all">All Status</option>
              <option value="pending">Pending</option>
              <option value="under_review">Under Review</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </Select>
            <div className="flex gap-2">
              <Button variant="outline" size="sm">
                <Icon name="Filter" size={16} />
              </Button>
              <Button variant="outline" size="sm">
                Bulk Actions
              </Button>
            </div>
          </div>
        </div>

        {/* Kanban Board */}
        <div className="flex-1 p-6 overflow-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 h-full">
            {statusColumns?.map((column) =>
            <div
              key={column?.id}
              className="bg-muted/30 rounded-lg p-4 h-full">

                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-medium text-foreground">{column?.label}</h3>
                  <span className={`px-2 py-1 rounded text-xs font-medium bg-${column?.color}-100 text-${column?.color}-800`}>
                    {getUsersByStatus(column?.id)?.length}
                  </span>
                </div>

                <div className="space-y-3">
                  {getUsersByStatus(column?.id)?.map((user) =>
                <div
                  key={user?.id}
                  onClick={() => setSelectedUser(user)}
                  className="bg-card border border-border rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow">

                      <div className="flex items-start gap-3">
                        <img
                      src={user?.profileImage}
                      alt={`${user?.name} profile picture`}
                      className="w-12 h-12 rounded-full object-cover flex-shrink-0" />

                        <div className="flex-1 min-w-0">
                          <h4 className="font-medium text-sm text-foreground truncate">
                            {user?.name}
                          </h4>
                          <p className="text-xs text-muted-foreground truncate">
                            {user?.email}
                          </p>
                          <div className="mt-2">
                            <span className={`inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-medium ${getUserTypeColor(user?.userType)}`}>
                              <Icon name={getUserTypeIcon(user?.userType)} size={10} />
                              {user?.userType}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Contact & Location */}
                      <div className="mt-3 text-xs text-muted-foreground">
                        <div className="flex items-center gap-1 mb-1">
                          <Icon name="Phone" size={10} />
                          {user?.phone}
                        </div>
                        <div className="flex items-center gap-1">
                          <Icon name="MapPin" size={10} />
                          {user?.location}
                        </div>
                      </div>

                      {/* Verification Score */}
                      <div className="mt-3 flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <div className={`w-2 h-2 rounded-full ${
                      user?.verificationScore >= 90 ? 'bg-green-500' :
                      user?.verificationScore >= 70 ? 'bg-yellow-500' : 'bg-red-500'}`
                      } />
                          <span className="text-xs text-muted-foreground">
                            {user?.verificationScore}% verified
                          </span>
                        </div>
                        <span className="text-xs text-muted-foreground">
                          {user?.submissionDate}
                        </span>
                      </div>

                      {/* KYC Status */}
                      <div className="mt-2">
                        <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${
                    user?.kycStatus === 'Verified' ? 'bg-green-100 text-green-800' :
                    user?.kycStatus === 'Under Review' ? 'bg-blue-100 text-blue-800' :
                    user?.kycStatus === 'In Progress' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`
                    }>
                          KYC: {user?.kycStatus}
                        </span>
                      </div>

                      {/* Quick Actions */}
                      {user?.status === 'pending' &&
                  <div className="mt-3 flex gap-2">
                          <Button
                      size="sm"
                      className="flex-1 h-8 text-xs"
                      onClick={(e) => {
                        e?.stopPropagation();
                        handleApprove(user);
                      }}>

                            <Icon name="Check" size={12} />
                            Approve
                          </Button>
                          <Button
                      variant="outline"
                      size="sm"
                      className="flex-1 h-8 text-xs"
                      onClick={(e) => {
                        e?.stopPropagation();
                        handleReject(user);
                      }}>

                            <Icon name="X" size={12} />
                            Reject
                          </Button>
                        </div>
                  }

                      {/* Flagged Issues */}
                      {user?.flaggedIssues?.length > 0 &&
                  <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded">
                          <div className="flex items-center gap-1">
                            <Icon name="AlertTriangle" size={12} className="text-red-500" />
                            <span className="text-xs text-red-700">
                              {user?.flaggedIssues?.length} issue(s)
                            </span>
                          </div>
                        </div>
                  }
                    </div>
                )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Detail Panel */}
      {selectedUser &&
      <div className="w-96 bg-card border-l border-border p-6 overflow-auto">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-foreground">User Details</h3>
            <Button
            variant="ghost"
            size="sm"
            onClick={() => setSelectedUser(null)}>

              <Icon name="X" size={16} />
            </Button>
          </div>

          <div className="space-y-6">
            {/* User Profile */}
            <div className="text-center">
              <img
              src={selectedUser?.profileImage}
              alt={`${selectedUser?.name} profile picture`}
              className="w-20 h-20 rounded-full object-cover mx-auto" />

              <h4 className="font-medium text-foreground mt-3">
                {selectedUser?.name}
              </h4>
              <p className="text-sm text-muted-foreground">
                {selectedUser?.email}
              </p>
              <div className="mt-2">
                <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium ${getUserTypeColor(selectedUser?.userType)}`}>
                  <Icon name={getUserTypeIcon(selectedUser?.userType)} size={14} />
                  {selectedUser?.userType}
                </span>
              </div>
            </div>

            {/* Contact Information */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Contact Information</h5>
              <div className="space-y-2 text-sm">
                <div className="flex items-center gap-2">
                  <Icon name="Phone" size={14} className="text-muted-foreground" />
                  <span>{selectedUser?.phone}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="Mail" size={14} className="text-muted-foreground" />
                  <span>{selectedUser?.email}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="MapPin" size={14} className="text-muted-foreground" />
                  <span>{selectedUser?.location}</span>
                </div>
              </div>
            </div>

            {/* Account Status */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Account Status</h5>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">Join Date</span>
                  <span className="text-sm font-medium">{selectedUser?.joinDate}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">Activity</span>
                  <span className={`text-sm font-medium ${
                selectedUser?.accountActivity === 'Active' ? 'text-green-600' : 'text-red-600'}`
                }>
                    {selectedUser?.accountActivity}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">KYC Status</span>
                  <span className={`px-2 py-1 rounded text-xs font-medium ${
                selectedUser?.kycStatus === 'Verified' ? 'bg-green-100 text-green-800' :
                selectedUser?.kycStatus === 'Under Review' ? 'bg-blue-100 text-blue-800' :
                selectedUser?.kycStatus === 'In Progress' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`
                }>
                    {selectedUser?.kycStatus}
                  </span>
                </div>
              </div>
            </div>

            {/* Document Verification */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Document Verification</h5>
              <div className="space-y-2">
                {selectedUser?.documents?.map((doc, index) =>
              <div key={index} className="flex items-center justify-between">
                    <span className="text-sm text-foreground">{doc}</span>
                    <Icon name="CheckCircle" size={16} className="text-green-500" />
                  </div>
              )}
              </div>
              
              {/* Verification Score */}
              <div className="mt-4 p-3 bg-muted rounded-lg">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Verification Score</span>
                  <span className="text-lg font-bold text-primary">
                    {selectedUser?.verificationScore}%
                  </span>
                </div>
                <div className="w-full bg-border rounded-full h-2 mt-2">
                  <div
                  className={`h-2 rounded-full ${
                  selectedUser?.verificationScore >= 90 ? 'bg-green-500' :
                  selectedUser?.verificationScore >= 70 ? 'bg-yellow-500' : 'bg-red-500'}`
                  }
                  style={{ width: `${selectedUser?.verificationScore}%` }} />

                </div>
              </div>
            </div>

            {/* Flagged Issues */}
            {selectedUser?.flaggedIssues?.length > 0 &&
          <div>
                <h5 className="font-medium text-foreground mb-3">Issues to Resolve</h5>
                <div className="space-y-2">
                  {selectedUser?.flaggedIssues?.map((issue, index) =>
              <div key={index} className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded">
                      <Icon name="AlertTriangle" size={14} className="text-red-500 mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-red-700">{issue}</span>
                    </div>
              )}
                </div>
              </div>
          }

            {/* Actions */}
            <div className="space-y-3">
              <Button className="w-full">
                <Icon name="Check" size={16} />
                Approve User
              </Button>
              <Button variant="outline" className="w-full">
                <Icon name="X" size={16} />
                Reject Account
              </Button>
              <Button variant="outline" className="w-full">
                <Icon name="MessageCircle" size={16} />
                Request Documents
              </Button>
              <Button variant="outline" className="w-full">
                <Icon name="UserX" size={16} />
                Suspend Account
              </Button>
            </div>
          </div>
        </div>
      }
    </div>);

};

export default UserAccountsTab;